<form [formGroup]="form">
  <formly-form [form]="form" [fields]="fields" [model]="model" />
</form>

<div class="d-flex flex-column-reverse flex-md-row justify-content-md-end mt-6 g-2">
  <ds-button
    label="Cancel"
    variant="secondary"
    (click)="back()"
    [disabled]="form.disabled"
    [fullWidth]="true"
    class="w-md-unset"
    data-id="back"
  />

  <ds-button
    label="Save changes"
    (click)="submit()"
    [disabled]="form.disabled"
    [fullWidth]="true"
    class="w-md-unset"
    data-id="submit"
  />
</div>
